import React from 'react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Router } from '../routes';
import routes from '../routes/definitions';
import { selectors as AuthSelectors } from '../redux/auth/redux';
import CookieSettingsButton from '../components/CookieSettingsButton';
export var useHeader = function useHeader() {
  var isConnected = useSelector(AuthSelectors.isConnected);
  return useMemo(function () {
    return {
      texts: {
        title: 'Balenciaga',
        powered: 'Powered By',
        login: 'Log In',
        logout: 'Log Out'
      },
      homePageLinkProps: {
        href: Router.getRouteUrl(routes.scholarship)
      },
      loginLinkProps: {
        href: Router.getRouteUrl(routes.login)
      },
      logoutLinkProps: {
        href: Router.getRouteUrl(routes.logout)
      },
      isLogged: isConnected
    };
  }, [isConnected]);
};
export var useFooter = function useFooter() {
  return {
    links: [{
      text: 'Cookie Policy',
      href: 'https://www.balenciaga.com/legal/politique-des-cookies/cookie-policy.html',
      target: '_blank'
    }, {
      text: 'Privacy policy',
      href: Router.getRouteUrl(routes.page, {
        slug: 'privacy-policy'
      }),
      target: '_blank'
    }, {
      text: 'Intellectual Property Policy',
      href: Router.getRouteUrl(routes.page, {
        slug: 'intellectual-property-policy'
      }),
      target: '_blank'
    }, {
      text: "\xA9 ".concat(new Date().getFullYear(), " Balenciaga"),
      href: 'http://www.balenciaga.com/',
      target: '_blank'
    }],
    cookieButton: /*#__PURE__*/React.createElement(CookieSettingsButton, {}, 'Cookie Settings')
  };
};